import React, { useEffect, useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../../config";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";

const emptyRow = {
  emp_id: "",
  overtime_date: new Date(),
  in_time: "",
  out_time: "",
  hours: "",
  remark: "",
};

const ManualOT = () => {
  const [employees, setEmployees] = useState([]);
  const [rows, setRows] = useState([{ ...emptyRow }]);

  /* =============================
     FETCH EMPLOYEES
  ==============================*/
  useEffect(() => {
    axios
      .get(API_BASE_URL + "/all_employees", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        setEmployees(res.data?.data?.all_employee || []);
      })
      .catch(() => toast.error("Failed to load employees"));
  }, []);

  /* =============================
     CALCULATE OT HOURS
  ==============================*/
  const calculateHours = (inTime, outTime) => {
    if (!inTime || !outTime) return "";

    const start = new Date(`1970-01-01T${inTime}`);
    const end = new Date(`1970-01-01T${outTime}`);

    let diff = (end - start) / 1000 / 60;
    if (diff < 0) diff += 1440;

    const hrs = Math.floor(diff / 60);
    const mins = diff % 60;

    return `${hrs}:${String(mins).padStart(2, "0")}`;
  };

  /* =============================
     UPDATE ROW
  ==============================*/
  const updateRow = (index, key, value) => {
    const updated = [...rows];
    updated[index][key] = value;

    if (key === "in_time" || key === "out_time") {
      updated[index].hours = calculateHours(
        updated[index].in_time,
        updated[index].out_time
      );
    }

    setRows(updated);
  };


     const generateTimeOptions = (step = 5) => {
  const options = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += step) {
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      options.push({
        label: `${hh}:${mm}`,
        value: `${hh}:${mm}`,
      });
    }
  }
  return options;
};

const timeOptions = generateTimeOptions(5); // 5-minute gap
  /* =============================
     ADD / REMOVE ROW
  ==============================*/
  const addRow = () => setRows([...rows, { ...emptyRow }]);
  const removeRow = (index) =>
    setRows(rows.filter((_, i) => i !== index));

  /* =============================
     FORM VALIDATION
  ==============================*/
  const isFormValid = rows.every(
    (r) => r.emp_id && r.in_time && r.out_time && r.hours && r.remark
  );

  /* =============================
     SUBMIT
  ==============================*/
  const submitOT = (e) => {
    e.preventDefault();

    axios
      .post(
        API_BASE_URL + "/add_manualot",
        { rows },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message);
        setRows([{ ...emptyRow }]);
      })
      .catch((error) => {
        toast.error(
          error.response?.data?.message || "Something went wrong"
        );
      });
  };

  /* =============================
     UI
  ==============================*/
  return (
    <>
      <ToastContainer position="bottom-right" theme="colored" />

      <form onSubmit={submitOT}>
        <div className="card">

          {/* HEADER */}
          <div className="card-header">
            <h4 className="mb-0">Add Manual OT</h4>
          </div>

          {/* BODY */}
          <div className="card-body">

            {/* COLUMN HEADERS */}
            <div className="row fw-bold text-muted mb-2">
              <div className="col-md-3">Employee</div>
              <div className="col-md-2">OT Date</div>
              <div className="col-md-1">In</div>
              <div className="col-md-1">Out</div>
              <div className="col-md-1">Hours</div>
              <div className="col-md-3">Reason</div>
              <div className="col-md-1 text-center">Action</div>
            </div>

            {/* DATA ROWS */}
            {rows.map((row, index) => (
              <div className="row align-items-center mb-2" key={index}>

                {/* EMPLOYEE */}
                <div className="col-md-3">
                  <Select
                    options={employees}
                    placeholder="Select Employee"
                    value={
                      employees.find(
                        (e) => e.value === row.emp_id
                      ) || null
                    }
                    onChange={(opt) =>
                      updateRow(index, "emp_id", opt?.value)
                    }
                  />
                </div>

                {/* DATE */}
                <div className="col-md-2">
                  <DatePicker
                    selected={row.overtime_date}
                    onChange={(date) =>
                      updateRow(index, "overtime_date", date)
                    }
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    maxDate={new Date()}
                  />
                </div>

                {/* IN */}
          <div className="col-md-1">
  <TimePicker
    showSecond={false}
    use12Hours
    inputReadOnly
    minuteStep={1}
    placeholder="In Time"
    value={
      row.in_time ? moment(row.in_time, "HH:mm") : null
    }
    onChange={(value) =>
      updateRow(
        index,
        "in_time",
        value ? value.format("HH:mm") : ""
      )
    }
    className="w-100"
  />
</div>








                {/* OUT */}
        <div className="col-md-1">
  <TimePicker
    showSecond={false}
    use12Hours
    inputReadOnly
    minuteStep={1}
    placeholder="Out Time"
    disabled={!row.in_time}
    value={
      row.out_time ? moment(row.out_time, "HH:mm") : null
    }
    onChange={(value) =>
      updateRow(
        index,
        "out_time",
        value ? value.format("HH:mm") : ""
      )
    }
    className="w-100"
  />
</div>






                {/* HOURS */}
                <div className="col-md-1">
                  <input
                    className="form-control bg-light"
                    value={row.hours}
                    placeholder="0:00"
                    readOnly
                  />
                </div>

                {/* REASON */}
                <div className="col-md-3">
                  <input
                    className="form-control"
                    placeholder="Reason"
                    value={row.remark}
                    disabled={!row.hours}
                    onChange={(e) =>
                      updateRow(index, "remark", e.target.value)
                    }
                  />
                </div>

                {/* ACTION */}
                <div className="col-md-1 text-center">
                  {index === rows.length - 1 ? (
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={addRow}
                    >
                      +
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => removeRow(index)}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* FOOTER */}
          <div className="card-footer d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-primary px-4"
              disabled={!isFormValid}
            >
              Save
            </button>
          </div>

        </div>
      </form>
    </>
  );
};

export default ManualOT;
